document.addEventListener('DOMContentLoaded', () => {



  // Nav Toggler

  const nav = document.querySelector('.nav-menu');
  const toggler = document.querySelector('.nav-toggler');
  const togglerMobile = document.querySelector('.nav-toggler-mb');
  function toggleMenu(trigger) {
    if (!nav) return;
    const isOpen = nav.classList.toggle('show');
    if (toggler) toggler.textContent = isOpen ? 'Close' : 'Menu';
    if (togglerMobile) togglerMobile.textContent = isOpen ? 'Close' : 'Menu';
  }
  if (toggler) {
    toggler.addEventListener('click', () => toggleMenu(toggler));
  }
  if (togglerMobile) {
    togglerMobile.addEventListener('click', () => toggleMenu(togglerMobile));
  }






  /* ------- NUTRITIONAL TABLE TOGGLER ------- */

  function initNutritionTable(section) {
    if (!section || section.dataset.nutritionInitialized === 'true') return;

    const table = section.querySelector('.panel-nutritional');
    const trigger = table?.querySelector('thead tr:first-child');

    if (!table || !trigger) return;

    section.dataset.nutritionInitialized = 'true';

    function applyState() {
      const isDesktop = window.innerWidth > 767;

      table.classList.toggle('is-collapsible', isDesktop);

      if (!isDesktop) {
        table.classList.remove('open');
      }
    }

    applyState();

    /* CLICK FIRST TABLE ROW */

    trigger.addEventListener('click', function () {
      if (window.innerWidth <= 767) return;

      table.classList.toggle('open');
    });

    /* RESPONSIVE */

    let wasDesktop = window.innerWidth > 767;

    window.addEventListener('resize', function () {
      const isDesktop = window.innerWidth > 767;

      if (isDesktop !== wasDesktop) {
        applyState();
        wasDesktop = isDesktop;
      }
    });
  }

  /* INITIALISE */

  function initAllNutritionTables(root = document) {
    if (root.matches?.('.wrapper-product-editorial')) {
      initNutritionTable(root);
    }

    root.querySelectorAll('.wrapper-product-editorial').forEach(initNutritionTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllNutritionTables();
    });
  } else {
    initAllNutritionTables();
  }

  /* SHOPIFY THEME EDITOR */

  document.addEventListener('shopify:section:load', function (event) {
    initAllNutritionTables(event.target);
  });


  /* FUNCTIONAL INGREDIENT TABS */



  function initFunctionalIngredients(section){
    if(!section || section.dataset.ingredientsInitialized === 'true') return;

    const tabs = [...section.querySelectorAll('.ingredient-tab')];
    const panels = [...section.querySelectorAll('.ingredient-panel')];
    const toggles = [...section.querySelectorAll('.ingredient-accordion-toggle')];
    const mobileQuery = window.matchMedia('(max-width:767px)');

    if(!tabs.length || tabs.length !== panels.length || tabs.length !== toggles.length) return;

    section.dataset.ingredientsInitialized = 'true';

    function activate(index,focus = false){
      const mobile = mobileQuery.matches;

      tabs.forEach((tab,i)=>{
        const active = i === index;
        const panel = panels[i];
        const toggle = toggles[i];

        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex = active ? 0 : -1;

        toggle.classList.toggle('is-active',active);
        toggle.setAttribute('aria-expanded',String(active));

        panel.classList.toggle('is-active',active);
        panel.hidden = !active;

        if(mobile){
          panel.setAttribute('aria-labelledby',toggle.id);
          panel.setAttribute('role','region');
        }else{
          panel.setAttribute('aria-labelledby',tab.id);
          panel.setAttribute('role','tabpanel');
        }
      });

      if(focus && index >= 0){
        tabs[index].focus();
      }
    }

    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>activate(index));

      tab.addEventListener('keydown',event=>{
        let next;

        if(event.key === 'ArrowRight'){
          next = (index+1)%tabs.length;
        }else if(event.key === 'ArrowLeft'){
          next = (index-1+tabs.length)%tabs.length;
        }else if(event.key === 'Home'){
          next = 0;
        }else if(event.key === 'End'){
          next = tabs.length-1;
        }else{
          return;
        }

        event.preventDefault();
        activate(next,true);
      });
    });

    toggles.forEach((toggle,index)=>{
      toggle.addEventListener('click',()=>{
        if(!mobileQuery.matches) return;

        const isActive = toggle.classList.contains('is-active');

        activate(isActive ? -1 : index);
      });
    });

    function handleBreakpointChange(){
      const activeIndex = tabs.findIndex(tab=>tab.classList.contains('is-active'));

      if(mobileQuery.matches){
        activate(activeIndex);
      }else{
        activate(activeIndex >= 0 ? activeIndex : 0);
      }
    }

    mobileQuery.addEventListener('change',handleBreakpointChange);

    activate(0);
  }

  function initAllFunctionalIngredients(root = document){
    if(root.matches?.('.wrapper-functional-ingredients')){
      initFunctionalIngredients(root);
    }

    root.querySelectorAll('.wrapper-functional-ingredients')
      .forEach(initFunctionalIngredients);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',()=>{
      initAllFunctionalIngredients();
    });
  }else{
    initAllFunctionalIngredients();
  }

  document.addEventListener('shopify:section:load',event=>{
    initAllFunctionalIngredients(event.target);
  });







  // const addToCart = document.querySelector('.wrapper-addtocart-mb');
  // const column = document.querySelector('.column-content');
  // function updatePosition() {
  //   const scrollY = window.scrollY;
  //   const viewportHeight = window.innerHeight;
  //   const columnRect = column.getBoundingClientRect();
  //   const columnBottom = scrollY + columnRect.bottom - 40;
  //   const barHeight = addToCart.offsetHeight;
  //   if (scrollY + viewportHeight < columnBottom) {
  //     addToCart.style.position = 'fixed';
  //     addToCart.style.bottom = '10px';
  //     addToCart.style.top = 'auto';
  //     addToCart.style.width = 'calc(100%)';
  //   }
  //   else {
  //     addToCart.style.position = 'relative';
  //     addToCart.style.bottom = 'auto';
  //     addToCart.style.top = 'auto';
  //     addToCart.style.width = 'calc(100% - 20px)';
  //   }
  // }
  //
  // window.addEventListener('scroll', updatePosition);
  // window.addEventListener('resize', updatePosition);
  //
  // updatePosition();


});
